import {
    getCData,
    saveCData
} from "./storage.js";
import {
    sendGA
} from "./ga.js";
import {
    sendLogApi
} from "./api.js";

/**
 * 取得頁面基本資訊
 * 資料來源：DOM/window object
 */
function getPageInfo() {
    return {
        url: location.href,
        ref: document.referrer,
        user_agent: navigator.userAgent,
    };
}

/**
 * 從 local storage 讀取 tracking 資料
 * 資料來源：localStorage
 */
function getStorageData() {
    return getCData();
}

/**
 * 從 URL parameters 讀取 tracking 資料
 * 資料來源：URL query string
 */
function getUrlParams() {
    const params = new URLSearchParams(window.location.search);
    return {
        c_src: params.get('c_src'),
        c_mod: params.get('c_mod') || 'none',
        c_info: params.get('c_info')
    };
}

export function sendPageview(url) {
    const providerCode = window.DC?.providerCode || undefined;
    const pageInfo = getPageInfo();
    const urlParams = getUrlParams();
    
    if (!providerCode) {
        console.log("缺少 provider_code，無法送出 pageview");
        return;
    }
    
    // 1. 抓取 URL parameters
    if (!urlParams.c_src) {
        console.log("缺少 c_src parameters，無法送出 pageview");
        return;
    }
    
    // 2. 比對 URL params 與 local storage
    const storageData = getStorageData();
    if (urlParams.c_src === storageData.c_src && 
        urlParams.c_mod === storageData.c_mod && 
        urlParams.c_info === storageData.c_info) {
        console.log("c_src / c_mod / c_info 與 local storage 相同，不送出 entry");
        return;
    }
    
    // 3. 回寫 local storage
    saveCData(urlParams.c_src, urlParams.c_mod, urlParams.c_info);

    // 4. 送出 GA and API
    sendGA("entry", {
        ...pageInfo,
        url: url,
        engagement_time_msec: 100,
        c_data: urlParams
    });
    const payload = {
        provider_code: providerCode,
        c_data: {
            ...urlParams,
            url: url
        },
        extra_data: {
            ref: pageInfo.ref,
            user_agent: pageInfo.user_agent
        }
    };
    console.log("pageview log payload:", payload);
    sendLogApi('entry', payload);
}

export function sendCheckout(payload) {
    const providerCode = window.DC?.providerCode || undefined;
    const pageInfo = getPageInfo();
    const storageData = getStorageData();
    
    if (!providerCode) {
        console.log("缺少 provider_code，無法送出 checkout");
        return;
    }
    if (!storageData.c_src || !storageData.c_mod) {
        console.log("缺少 c_src 或 c_mod，無法送出 checkout");
        return;
    }
    if (!payload.items) {
        console.log("缺少 items，無法送出 checkout");
        return;
    }

    sendGA("purchase", {
        provider_code: providerCode,
        transaction_id: payload.order_id,
        value: payload.total_price,
        currency: "TWD",
        shipping: payload.shipping_cost,
        items: payload.items?.map(i => ({
            item_id: i.item_id,
            item_name: i.item_name || "N/A",
            price: i.price,
            quantity: i.quantity,
        })),
        c_data: storageData
    });
    const params = {
        provider_code: providerCode,
        c_data: {
            ...storageData,
            url: pageInfo.url
        },
        items: payload.items?.map(i => ({
            item_id: i.item_id,
            item_name: i.item_name || "N/A",
            price: i.price,
            quantity: i.quantity,
            total_price: i.total_price ? i.total_price : i.price * i.quantity
        })),
        extra_data: {
            ref: pageInfo.ref,
            user_agent: pageInfo.user_agent,
            order_id: payload.order_id,
            shipping_cost: payload.shipping_cost,
            total_price: payload.total_price ? payload.total_price : payload.items?.reduce((a, b) => a + b.price * b.quantity, 0) + (payload.shipping_cost || 0)
        }
    };
    console.log("checkout log payload:", params);
    sendLogApi('purchase', params);
}

export function sendAddToCart(payload) {
    const providerCode = window.DC?.providerCode || undefined;
    const pageInfo = getPageInfo();
    const storageData = getStorageData();
    
    if (!providerCode) {
        console.log("缺少 provider_code，無法送出 add_to_cart");
        return;
    }
    if (!storageData.c_src || !storageData.c_mod) {
        console.log("缺少 c_src 或 c_mod，無法送出 add_to_cart");
        return;
    }
    if (!payload.items) {
        console.log("缺少 items，無法送出 add_to_cart");
        return;
    }

    sendGA("add_to_cart", {
        currency: "TWD",
        value: payload.items?.reduce((a, b) => a + b.price * b.quantity, 0),
        items: payload.items?.map(i => ({
            item_id: i.item_id,
            item_name: i.item_name || "N/A",
            price: i.price,
            quantity: i.quantity
        })),
        c_data: storageData
    });
    const params = {
        provider_code: providerCode,
        c_data: {
            ...storageData,
            url: pageInfo.url
        },
        items: payload.items?.map(i => ({
            item_id: i.item_id,
            item_name: i.item_name || "N/A",
            price: i.price,
            quantity: i.quantity,
            total_price: i.total_price ? i.total_price : i.price * i.quantity
        })),
        extra_data: {
            ref: pageInfo.ref,
            user_agent: pageInfo.user_agent,
        }
    };
    console.log("add_to_cart log payload:", params);

    sendLogApi('cart', params);
}